<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="success" @click="handleAdd">新增权益</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="rightsList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
            <el-table-column fixed prop="rightName" label="权益名称"></el-table-column>
            <el-table-column fixed prop="rightType" label="权益类型" :formatter="formatRightType"></el-table-column>
            <el-table-column fixed prop="status" label="状态" :formatter="formatStatus"></el-table-column>
            <el-table-column prop="level1" label="LEVEL 1" width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight1==1" @click="roleSet(scope.row.id1,scope.row.hasRight1)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight1==0" @click="roleSet(scope.row.id1,scope.row.hasRight1)">无</el-button>
                    <span>{{scope.row.level1}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id1,scope.row.level1,scope.row.rightDirectUrl1,scope.row.hasRight1,'1')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level2" label="LEVEL 2"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight2==1" @click="roleSet(scope.row.id2,scope.row.hasRight2)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight2==0" @click="roleSet(scope.row.id2,scope.row.hasRight2)">无</el-button>
                    <span>{{scope.row.level2}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id2,scope.row.level2,scope.row.rightDirectUrl2,scope.row.hasRight2,'2')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level3" label="LEVEL 3"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight3==1" @click="roleSet(scope.row.id3,scope.row.hasRight3)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight3==0" @click="roleSet(scope.row.id3,scope.row.hasRight3)">无</el-button>
                    <span>{{scope.row.level3}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id3,scope.row.level3,scope.row.rightDirectUrl3,scope.row.hasRight3,'3')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level4" label="LEVEL 4"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight4==1" @click="roleSet(scope.row.id4,scope.row.hasRight4)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight4==0" @click="roleSet(scope.row.id4,scope.row.hasRight4)">无</el-button>
                    <span>{{scope.row.level4}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id4,scope.row.level4,scope.row.rightDirectUrl4,scope.row.hasRight4,'4')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level5" label="LEVEL 5"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight5==1" @click="roleSet(scope.row.id5,scope.row.hasRight5)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight5==0" @click="roleSet(scope.row.id5,scope.row.hasRight5)">无</el-button>
                    <span>{{scope.row.level5}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id5,scope.row.level5,scope.row.rightDirectUrl5,scope.row.hasRight5,'5')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level6" label="LEVEL 6"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight6==1" @click="roleSet(scope.row.id6,scope.row.hasRight6)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight6==0" @click="roleSet(scope.row.id6,scope.row.hasRight6)">无</el-button>
                    <span>{{scope.row.level6}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id6,scope.row.level6,scope.row.rightDirectUrl6,scope.row.hasRight6,'6')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level7" label="LEVEL 7"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight7==1" @click="roleSet(scope.row.id7,scope.row.hasRight7)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight7==0" @click="roleSet(scope.row.id7,scope.row.hasRight7)">无</el-button>
                    <span>{{scope.row.level7}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id7,scope.row.level7,scope.row.rightDirectUrl7,scope.row.hasRight7,'7')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level8" label="LEVEL 8"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight8==1" @click="roleSet(scope.row.id8,scope.row.hasRight8)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight8==0" @click="roleSet(scope.row.id8,scope.row.hasRight8)">无</el-button>
                    <span>{{scope.row.level8}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id8,scope.row.level8,scope.row.rightDirectUrl8,scope.row.hasRight8,'8')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level20" label="白金"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight20==1" @click="roleSet(scope.row.id20,scope.row.hasRight20)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight20==0" @click="roleSet(scope.row.id20,scope.row.hasRight20)">无</el-button>
                    <span>{{scope.row.level20}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id20,scope.row.level20,scope.row.rightDirectUrl20,scope.row.hasRight20,'20')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="level21" label="黄金"  width="200">
                <template slot-scope="scope">
                    <el-button type="info" size="mini" v-if="scope.row.hasRight21==1" @click="roleSet(scope.row.id21,scope.row.hasRight21)">有权限</el-button>
                    <el-button type="info" size="mini" v-if="scope.row.hasRight21==0" @click="roleSet(scope.row.id21,scope.row.hasRight21)">无</el-button>
                    <span>{{scope.row.level21}}</span>
                    <el-button type="small" size="mini" @click="rightUpdate(scope.row,scope.row.id21,scope.row.level21,scope.row.rightDirectUrl21,scope.row.hasRight21,'21')">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="rightId" label="rightId" v-if="isShowRightId"></el-table-column>
            <el-table-column label="操作" fixed="right" width="290">
                <template slot-scope="scope">
                    <el-button type="small" size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="danger" size="mini" v-if="scope.row.status==1" @click="handledDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="添加会员权益" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="权益名称">
                    <el-input v-model="form.rightName" placeholder="权益名称"></el-input>
                </el-form-item>
                <el-form-item label="权益类型" >
                    <el-select v-model="form.rightType" clearable  placeholder="权益类型">
                        <el-option label="会员日单品折扣" value="1"></el-option>
                        <el-option label="会员专属套装折扣" value="2"></el-option>
                        <el-option label="新品尝鲜权益" value="3"></el-option>
                        <el-option label="秒杀" value="4"></el-option>
                        <el-option label="提前秒杀" value="5"></el-option>
                        <el-option label="5元私人定制礼品" value="6"></el-option>
                        <el-option label="免费私人定制礼品" value="7"></el-option>
                        <el-option label="LV4专属赠品" value="8"></el-option>
                        <el-option label="LV5专属赠品" value="9"></el-option>
                        <el-option label="Foodie Pass商城" value="10"></el-option>
                        <el-option label="门店随时9折" value="11"></el-option>
                        <el-option label="秒杀预约" value="12"></el-option>
                        <el-option label="社群" value="13"></el-option>
                        <el-option label="专属赠礼" value="14"></el-option>
                        <el-option label="生日赠礼" value="15"></el-option>
                        <el-option label="日常单品折扣" value="16"></el-option>
                        <el-option label="会员赠品" value="17"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否展示" >
                    <el-select v-model="form.isShow" clearable  placeholder="是否展示">
                        <el-option label="展示" value="1"></el-option>
                        <el-option label="不展示" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" >
                    <el-select v-model="form.status" clearable  placeholder="状态">
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addRight(form)">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改会员权益" :visible.sync="editVipRights" center>
            <el-form :model="vipForm" label-width="120px">
                <el-form-item label="当前等级">
                    <el-input v-model="vipForm.level" :disabled="true" placeholder="当前等级"></el-input>
                </el-form-item>
                <el-form-item label="权益名称">
                    <el-input v-model="vipForm.rightName" :disabled="true" placeholder="权益名称"></el-input>
                </el-form-item>
                <el-form-item label="权益数据">
                    <el-input v-model="vipForm.rightData" placeholder="权益数据"></el-input>
                </el-form-item>
                <el-form-item label="弹窗跳转URL">
                    <el-input v-model="vipForm.rightDirectUrl" placeholder="弹窗跳转URL">
                    </el-input>
                </el-form-item>
                <el-form-item label="是否拥有权限" >
                    <el-select v-model="vipForm.hasRight" clearable  placeholder="是否拥有权限">
                        <el-option label="有" value="1"></el-option>
                        <el-option label="无" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <selectPicComponents :selectImages="{'proId':vipForm.id,'picType':201,'proName':vipForm.rightName,'limitCount':1,'btnText':'亮ICON'}"></selectPicComponents>
                <selectPicComponents :selectImages="{'proId':vipForm.id,'picType':202,'proName':vipForm.rightName,'limitCount':1,'btnText':'暗ICON'}"></selectPicComponents>
                <selectPicComponents :selectImages="{'proId':vipForm.id,'picType':204,'proName':vipForm.rightName,'limitCount':1,'btnText':'弹窗图'}"></selectPicComponents>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editVipRights = false">取 消</el-button>
                <el-button type="primary" @click="addVipRight(vipForm)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
     //导入 HTTP请求方法
    import {rightsList,saveVipRights,deleteVipRights,rightsChangeStatus,updateByIdLevel} from '../../api/api'
    import selectPicComponents from '@/components/selectPic';
    //定义组件
    export default{
        data(){
            return {
                rightsList:[],
                loading:true,
                selectValue: '',
                isShowRightId: false,
                dialogFormVisible:false,
                editVipRights:false,
                form:{
                    "id" : "",
                    "rightName":"",
                    "rightType":"",
                    "status":"",
                    "isShow":"",
                    "rightId":""
                },
                vipForm:{
                    "id" : "",
                    "level":"",
                    "rightName":"",
                    "rightType":"",
                    "rightId":"",
                    "rightDirectUrl":"",
                    "rightData":"",
                    "hasRight":"",

                },
                formInline:{
                    currentPage:1,
                    recordsTotal:0,
                    pageSize:10,
                }
            }
        },
        components:{
            selectPicComponents
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        methods:{
            //权益类型显示转换
            formatRightType: function (row, column) {
                var typeName = '未知'
                if(row.rightType == 1){
                    typeName = '会员日单品折扣'
                }
                if(row.rightType == 2){
                    typeName = '会员专属套装折扣'
                }
                if(row.rightType == 3){
                    typeName = '新品尝鲜权益'
                }
                if(row.rightType == 4){
                    typeName = '秒杀'
                }
                if(row.rightType == 5){
                    typeName = '提前秒杀'
                }
                if(row.rightType == 6){
                    typeName = '5元私人定制礼品'
                }
                if(row.rightType == 7){
                    typeName = '免费私人定制礼品'
                }
                if(row.rightType == 8){
                    typeName = 'LV4专属赠品'
                }
                if(row.rightType == 9){
                    typeName = 'LV5专属赠品'
                }
                if(row.rightType == 10){
                    typeName = 'Foodie Pass商城'
                }
                if(row.rightType == 11){
                    typeName = '门店随时9折'
                }
                if(row.rightType == 12){
                    typeName = '秒杀预约'
                }
                if(row.rightType == 13){
                    typeName = '社群'
                }
                if(row.rightType == 14){
                    typeName = '专属赠礼'
                }
                if(row.rightType == 15){
                    typeName = '生日赠礼'
                }
                if(row.rightType == 16){
                    typeName = '日常单品折扣'
                }
                if(row.rightType == 17){
                  typeName = '会员赠品'
                }
                return typeName;
            },

            //状态类型转换
            formatStatus: function (row, column) {
                return row.status == 0 ? '已禁用' : row.status == 1 ? '已启用' : '未知';
            },

            //定义查询方法
            getList(){
                this.loading = true;
                rightsList(this.formInline).then((res) => {
                    this.loading = false;
                    this.rightsList = res.data.list;
                    this.formInline.recordsTotal = res.data.total;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },

            //修改
            handleUpdate(row){
                this.form.id = row.id;
                this.form.rightId = row.rightId;
                this.form.rightName = row.rightName;
                this.form.rightType = row.rightType;
                this.form.status = row.status;
                this.form.isShow = row.isShow;
                this.dialogFormVisible = true;
            },

            //删除
            handledDelete(row){
                this.$confirm('删除权益, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteVipRights({rightId:row.rightId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage,this.pageSize);
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },

            //新增
            handleAdd(){
                this.dialogFormVisible = true;
                this.form.rightName="";
                this.form.rightType="";
                this.form.isShow="";
                this.form.status="";
            },

            //保存
            addRight(form){
                if(form.rightName==""){
                    this.$message({
                        message:"请输入权益名称",
                        type:'error'
                    });
                    return;
                }
                if(form.rightType==""){
                    this.$message({
                        message:"请选择权益类型",
                        type:'error'
                    });
                    return;
                }
                if(form.isShow==""){
                    this.$message({
                        message:"请选择是否展示",
                        type:'error'
                    });
                    return;
                }
                if(form.status==""){
                    this.$message({
                        message:"请选择状态",
                        type:'error'
                    });
                    return;
                }

                saveVipRights(form).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList(this.currentPage,this.pageSize);
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },

            addVipRight(vipForm){
                updateByIdLevel(vipForm).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.editVipRights = false;
                        this.getList(this.currentPage,this.pageSize);
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
             },

            //有无权限
            roleSet(id,hasRight){
                rightsChangeStatus({id:id,hasRight:hasRight}).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList(this.currentPage,this.pageSize);
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },

            //修改
            rightUpdate(row,id,level,rightDirectUrl,hasRight,rowIndex){
                this.vipForm.id = id;
                this.vipForm.level = rowIndex;
                this.vipForm.rightName = row.rightName;
                this.vipForm.rightType = row.rightType;
                this.vipForm.rightDirectUrl = rightDirectUrl;
                this.vipForm.rightData = level;
                this.vipForm.hasRight = hasRight;
                this.editVipRights = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/vip/vipRight.vue